import React from "react";
import BannerSection from "../BannerSection/BannerSection";
import EventSection from "../EventSection/EventSection";

const Home = () => {
  return (
    <div>
      <BannerSection></BannerSection>
      <EventSection />
    </div>
  );
};

export default Home;
